import * as z from "zod";

export const customerReportSchema = z.object({
    requestorName: z
    .string()
    .trim()
    .min(1, "작성자를 입력해주세요."),
    dateOfBirth: z
    .date({ required_error: "생년월일을 입력해주세요." })
    .refine((val) => !isNaN(val.getTime()), {
      message: "유효한 생년월일을 입력해주세요.",
    }),
    mobileNo: z
    .string()
    .regex(/^\d{8,11}$/, "휴대폰 번호는 8~11자리 숫자여야 합니다."),
    email: z
    .string()
    .email("유효한 이메일 주소를 입력해주세요."),
    title: z
    .string()
    .trim()
    .min(1, "문의 제목을 입력해주세요."),
    contents: z
    .string()
    .trim()
    .min(10, "문의 내용은 10자 이상 입력해주세요.")
    .max(1000, "문의 내용은 1000자 이하로 입력해주세요."),
    agree: z
    .literal('agree', {
        errorMap: () => ({ message: '개인정보 수집 및 이용에 동의하셔야 제출이 가능합니다.' })
    })
});

// 🔹 타입 정의
export type CustomerReportFormValues = z.infer<typeof customerReportSchema>;